import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../stores/store";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthContext from "../../context/AuthProvider";

const Sidebar = ({ isSidebarOpen, toggleSidebar }) => {
  const { t } = useTranslation();
  const { mainStore } = useStore();
  const { auth } = useContext(AuthContext);


  const MainMenuItems = [
    {
      path: "/Home",
      displayName: t("dashboard"),
      iconClass: "bi bi-house-fill",
      roles: ["admin"],
      subCategory: ["MenuPortal"],
      menuNo: mainStore.HomeMenuNo,
    },
    {
      path: "/Profile",
      displayName: t("personalInformation"),
      iconClass: "bi bi-person-fill",
      roles: ["admin"],
      subCategory: ["MenuPortal"],
      menuNo: mainStore.ProfileMenuNo,
    },
    {
      path: "/SchedulePlan/List",
      displayName: t("schedulePlan"),
      iconClass: "bi bi-calendar3",
      roles: ["admin"],
      subCategory: ["MenuPortal"],
      menuNo: mainStore.SchedulePlanMenuNo,
    },
    {
      path: "/SchedulePlan/ReplacementScheduleList",
      displayName: t("replacementSchedule"),
      iconClass: "bi bi-arrow-repeat",
      roles: ["admin"],
      subCategory: ["MenuPortal"],
      menuNo: mainStore.ReplacementScheduleMenuNo,
    },
    {
      path: "/ExamPlan/List",
      displayName: t("myExamPlan"),
      iconClass: "bi bi-calendar-event",
      roles: ["admin"],
      subCategory: ["MenuPortal"],
      menuNo: mainStore.ExamPlanMenuNo,
    },
    {
      path: "/ExamRegistration/List",
      displayName: t("registerGrades"),
      iconClass: "bi bi-pencil-square",
      roles: ["admin"],
      subCategory: ["MenuPortal"],
      menuNo: mainStore.ExamRegistrationMenuNo,
    },
    {
      path: "/ExamRegistration/GradeManagement",
      displayName: t("resetGrades"),
      iconClass: "bi bi-arrow-counterclockwise",
      roles: ["admin"],
      subCategory: ["MenuPortal"],
      menuNo: mainStore.GradeManagementMenuNo,
    },
    {
      path: "/Help",
      displayName: t("profileHelp"),
      iconClass: "bi bi-question-circle-fill",
      roles: ["admin"],
      subCategory: ["MenuPortal"],
      menuNo: mainStore.HelpMenuNo,
    },
  ];


  const renderMenuItems = (menuItems, menuCategory) => {
    const menuItemsResult = menuItems
      .filter(item => item.subCategory == menuCategory)
      .map(item => (
        <li className="nav-item" key={item.menuNo}>
          <Link
            to={item.path}
            className={`nav-link ${mainStore.menuNo == item.menuNo ? "active bg-danger bg-opacity-10 text-danger rounded" : "text-dark"}`}
            onClick={toggleSidebar}
            style={{ fontSize: '0.9rem', padding: '0.5rem 1rem', transition: 'all 0.2s' }}
          >
            <i className={`${item.iconClass} me-2`} style={{ fontSize: '1rem' }}></i>
            {item.displayName}
          </Link>
        </li>
      ));

    if (menuItemsResult.length == 0) return null;

    return (
      <>
        <li className="nav-item mt-3" key={menuCategory}>
          <h6 className="ms-3 text-uppercase text-danger fw-bold" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
            {t(menuCategory)}
          </h6>
        </li>
        <hr className="horizontal mt-0 mb-2 mx-3 border-danger opacity-25" />
        {menuItemsResult}
      </>
    );
  };

  return (
    <div className="py-3">
      <ul className="nav flex-column">
        {mainStore.menuType === 1000 && renderMenuItems(MainMenuItems, "MenuPortal")}
      </ul>
    </div>
  );
}

export default observer(Sidebar);

